<template>
  <div class="opera-centerInfo"
       style="background-color: #f7f8fa">
    <topNav :title="$t('centerinfo_title')"
            url='/opera/centerHuanQiu'
            replace="true"></topNav>
    <ul class="perInfo">
      <mt-cell :title="$t('centerinfo_code')"
               :value="perInfo.code"></mt-cell>
      <mt-cell :title="$t('hotelGroupName')"
               :value="perInfo.hotelGroupName"></mt-cell>
      <mt-cell :title="$t('hotelName')"
               :value="perInfo.hotelName"></mt-cell>
      <mt-cell :title="$t('bizDate')"
               :value="perInfo.bizDate | dateF"></mt-cell>
      <mt-cell :title="$t('name')"
               :value="perInfo.name"></mt-cell>
      <mt-cell :title="$t('sex')"
               :value="perInfo.sex"></mt-cell>
      <mt-cell :title="$t('roles')"
               :value="perInfo.roles"></mt-cell>
      <mt-cell :title="$t('mobile')"
               :value="perInfo.mobile"></mt-cell>
      <a class="mint-cell">
        <div class="mint-cell-left"></div>
        <div class="mint-cell-wrapper">
          <div class="mint-cell-title">
            <span class="mint-cell-text">{{$t('centerinfo_mac')}}</span>
          </div>
          <div class="mint-cell-value">
            <span style="font-size:12px">{{perInfo.mac}}</span>
          </div>
        </div>
        <div class="mint-cell-right"></div>
      </a>
      <mt-cell :title="$t('lastLoginDate')"
               :value="perInfo.lastLoginDate"></mt-cell>
      <mt-cell :title="$t('lastIp')"
               :value="perInfo.lastIp"></mt-cell>
    </ul>
  </div>
</template>
<script>
  import { Toast, MessageBox } from "mint-ui";
  export default {
    data() {
      return {
        perInfo: {}
      };
    },
    mounted() {
      this.$http.post("/mobilepmsapi/sys/getUserInfo").then(res => {
        if (res.data.result == 0) {
          this.perInfo = res.data.retVal;
        }
      });
    },
    methods: {},
    filters: {
      dateF(value) {
        if (value == null || value == "") {
          return "";
        }
        return value.substring(0, 10);
      }
    },
    components: {}
  };
</script>
<style lang='less' scoped>
  .opera-centerInfo {
    .perInfo {
      background: #fff;
      overflow: hidden;
      margin-top: 0.4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// huanqiuCenterInfo.vue?501e60d1